import React from "react";
import Intercom from "@intercom/messenger-js-sdk";

export default function IntercomComponent() {
    Intercom({
        app_id: "gtv7od0v",
    });

    return <></>;
}
